const OpCodeStart = 50;
export enum ConsumableComponentOpCodes {
  OnConsume = OpCodeStart + 1,
}
